import { render, staticRenderFns } from "./image-engrais.vue?vue&type=template&id=711564d1&"
import script from "./image-engrais.vue?vue&type=script&lang=ts&"
export * from "./image-engrais.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports